import {
  BankingIntegrationConfig,
  BankingReports,
} from '@/pages/Profile/components'
import { api } from './api'

enum TinkConnectionStatus {
  Pending = 'pending',
  AwaitingConfirmation = 'awaiting-confirmation',
  Connected = 'connected',
}

enum TinkConnectionSource {
  YearlyCheckIn = 'yearly-check-in',
  ProfileIntegrations = 'profile-integrations',
}

interface TinkConnectionMetadata {
  locationId: string
}

interface TinkConnection {
  id: string
  user_id: string
  xs2a_connection_id: string | null
  status: TinkConnectionStatus
  source: TinkConnectionSource
  metadata: TinkConnectionMetadata | null
}

interface TinkConnectionsResponse {
  connections: TinkConnection[]
}

export const getTinkConnections = (): Promise<TinkConnectionsResponse> =>
  api.get('/user/psd2/connections')

export const getTinkAccountCheckLink = (config: BankingIntegrationConfig) => {
  return api.post('/user/psd2/connections', config)
}

export const finishTinkConnection = (): Promise<void> =>
  api.post('/user/psd2/connections/finished')

export const fetchTinkReports = (): Promise<BankingReports> =>
  api.get('/user/psd2/reports')
